import ReactGA from "react-ga4";

export const colors = {
  alternatives: [
    '#2fcdde',
    '#5bba78',
    '#f9b454',
    '#83a1c1',
    '#fc9ca4',
    '#a4fc9c',
    '#ecf953',
    '#C0C6FF',
    '#f96254',
    '#527e4e',
    '#8d9531',
    '#6d72b0',
    '#ae443a',
    '#dddddd',
    '#666666',
    '#2aa5a5',
    '#fdd7da',
    '#e3e6ff',
    '#B4DADE',
    '#A0C7AC',
    '#FCDBAE',
    '#BFCBD7',
    '#81B0B5',
    '#FFCC7E',
    '#DF5B4F',
    '#111111',
    '#B47C28',
  ],
}

/**
 * URL base del API, derivada automáticamente del entorno en tiempo de ejecución.
 *
 * Convención: el API vive en el subdominio `api.` del mismo dominio que la web
 * (ej. web en otea.info → api en api.otea.info; otea.zitric.net → api.otea.zitric.net).
 * En local se apunta al backend de desarrollo. El prefijo `/api` lo añade el route
 * group de Laravel (RouteServiceProvider), igual que en el contrato original.
 *
 * Override opcional: definir `REACT_APP_SERVER_URL` en el build fuerza una base fija
 * (para entornos que no sigan la convención api.<host>).
 */
export const getAbsoluteServerUrl = (relativeServerUrl: string) => {
  const baseUrl = resolveServerBaseUrl()
  return `${baseUrl}${relativeServerUrl}`
}

export type EntornoApi = {
  protocol: string;
  hostname: string;
  configurada?: string;
}

const HOSTS_LOCALES = ['localhost', '127.0.0.1', '0.0.0.0']

/**
 * Base del API a partir del entorno, como función pura: se le pasa el entorno a
 * mano, así que se testea sin redefinir `window.location` (jsdom ha ido
 * restringiendo si eso se puede, y el test fallaba por eso, no por el código).
 */
export const derivarBaseApi = ({ protocol, hostname, configurada }: EntornoApi): string => {
  // Override opcional: un valor no vacío fuerza una base fija.
  if (configurada) return configurada

  if (HOSTS_LOCALES.includes(hostname)) {
    return `${protocol}//localhost:8000/api`
  }

  // api.<host> sin posible www. inicial → base sin sufijo (el /api lo pone Laravel)
  return `${protocol}//api.${hostname.replace(/^www\./, '')}/api`
}

function resolveServerBaseUrl(): string {
  return derivarBaseApi({
    protocol: window.location.protocol,
    hostname: window.location.hostname,
    configurada: process.env.REACT_APP_SERVER_URL,
  })
}

const GAnalyticsIDKey = 'G-HTXCZ1M8F2';

export const initGA = () => {
  ReactGA.initialize(GAnalyticsIDKey);
};